
module.exports = { 
      attributes: {},
    
      body: "# Footer Dev\n\nThis is a short page to keep footers from scrolling.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/static/default/footer-dev.md"},
     }